export default __webpack_public_path__ + "static/media/baking.bb450549.jpg";